export default __webpack_public_path__ + "static/media/ic-mic.93828c32.svg";